
export const CLIENT_ID = "openground-cloud-collaboration-portal";
export const AUTHORISE_HEADER = 'Basic b3Blbmdyb3VuZC1jbG91ZC13ZWItcG9ydGFsOkNsaWVudFNlY3JldA==';
export const TOKEN_KEY = "KeynetixPortalToken";
export const REFRESH_TOKEN_KEY = "KeynetixPortalRefreshToken";
export const CUSTOMER_ID_KEY = "KeynetixPortalCustomerId";
export const TOKEN_USAGE_COUNTER_KEY = "KeynetixPortal.TokenUsageCounter";
export const TOKEN_RETRIEVED_TIME_KEY = "KeynetixPortal.TokenRetrievedTime";
export const TOKEN_REFRESH_INTERVAL = 300000; // 5 minutes
export const USER_DETAILS = "KeynetixCurrentUserDetails";
export const USER_IS_ADMIN = "KeynetixCurrentUserIsAdmin";
export const kendoPropertySplitter = "_$";
